/**
 * Notifications API Slice
 * RTK Query endpoints for FCM token management
 */

import { apiSlice } from "./apiSlice";

export const notificationsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Register FCM token for the current guest session
     */
    registerGuestFCMToken: builder.mutation({
      query: (tokenData) => ({
        url: "/fcm-tokens/register-guest",
        method: "POST",
        body: {
          deviceId: tokenData.deviceId,
          platform: tokenData.platform || "web",
          token: tokenData.token,
          appVersion: tokenData.appVersion,
          deviceInfo: tokenData.deviceInfo,
          timezone: tokenData.timezone,
        },
      }),
    }),

    /**
     * Remove FCM token from the current guest session
     */
    removeGuestFCMToken: builder.mutation({
      query: (token) => ({
        url: "/fcm-tokens/remove-guest",
        method: "POST",
        body: { token },
      }),
    }),
  }),
});

export const {
  useRegisterGuestFCMTokenMutation,
  useRemoveGuestFCMTokenMutation,
} = notificationsApi;
